import { RECEIVE_PARTNERS_MAINTENANCE } from './types';

const initialState = {
	partners: false,
};

const reducer = function maintenanceReducer(state = initialState, action) {
	switch (action.type) {
		case RECEIVE_PARTNERS_MAINTENANCE:
			return { ...state, partners: !!action.data };

		default:
			return state;
	}
};

export default reducer;
